import type { AxiosRequestConfig } from 'axios'

import { SPANISH_SUBDIRECTORY } from '../../constants/api'
import { VITE_API_URL, VITE_API_URL_2 } from '../../constants/config'
import { isApi2 } from './isApi2'

export function getApiOrigin(axiosRequestConfig: AxiosRequestConfig) {
  let domain = VITE_API_URL
  if (isApi2(axiosRequestConfig)) domain = VITE_API_URL_2

  const subdirectory = SPANISH_SUBDIRECTORY

  return `${domain}${subdirectory}`
}
